/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgLoad24(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={24}
      height={24}
      fill='none'
      viewBox='0 0 24 24'
      {...props}
    >
      <path
        stroke='#fff'
        strokeLinecap='square'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11z'
        opacity={0.4}
      />
      <path
        stroke='#fff'
        strokeMiterlimit={10}
        strokeWidth={1.5}
        d='M12 1a11 11 0 0111 11'
      />
    </svg>
  );
}

export default SvgLoad24;
